import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { userActions } from "../../store/user-store/user-slice";
import { uiActions } from "../../store/ui-slice";
import { useEffect, useState } from "react";
import { GetUser, UpdateUser } from "../../store/user-store/user-actions";
import { getTokenInfo } from "../../utils/Guard";
import { GetCountries } from "../../store/country-store/country-actions";
import { GetCharges } from "../../store/charge-store/charge-actions";
import { GetOrganizations } from "../../store/organization-store/organization-actions";
import { GetDepartments } from "../../store/department-store/department-actions";
import { Getdocumenttypes } from "../../store/documenttype-store/documenttype-actions";
import { Dropdown } from "primereact/dropdown";
import { OverlayPanel } from "primereact/overlaypanel";
import { InputMask } from "primereact/inputmask";

let restartPage = false;

const ExternalSignForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const param = useParams();
  const op = useRef(null);

  const isValid = useSelector((state) => state.user.userValidation);
  const user = useSelector((state) => state.user.user);
  const userInfo = getTokenInfo();
  const notification = useSelector((state) => state.ui.notification);
  const countries = useSelector((state) => state.country.countries);
  const charges = useSelector((state) => state.charge.charges);
  const organizations = useSelector(
    (state) => state.organization.organizations
  );
  const departments = useSelector((state) => state.department.departments);
  const documenttypes = useSelector(
    (state) => state.documenttype.documenttypes
  );
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedDocumenttype, setSelectedDocumenttype] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [selectedPassword, setSelectedPassword] = useState(null);

  const profiles = [
    { name: "Perteneciente", code: "PFnubeQABAPerteneciente" },
    { name: "Representante", code: "REPqscdABA" },
  ];

  useEffect(() => {
    if (user.id === undefined || user.id === 0) {
      dispatch(GetUser(param.userId, userInfo.Email, true));
    }
  }, [param.userId, userInfo.Email, dispatch, user]);

  useEffect(() => {
    if (organizations && organizations.length === 0) {
      dispatch(GetOrganizations(userInfo.Email));
    }
  }, [organizations, dispatch]);

  useEffect(() => {
    if (documenttypes && documenttypes.length === 0) {
      dispatch(Getdocumenttypes(userInfo.Email));
    }
  }, [documenttypes, dispatch]);

  useEffect(() => {
    if (departments && departments.length === 0) {
      dispatch(GetDepartments(userInfo.Email));
    }
  }, [departments, dispatch]);

  useEffect(() => {
    if (countries && countries.length === 0) {
      dispatch(GetCountries(userInfo.Email));
    }
  }, [countries, dispatch]);

  useEffect(() => {
    if (charges && charges.length === 0) {
      dispatch(GetCharges(userInfo.Email));
    }
  }, [charges, dispatch]);

  useEffect(() => {
    if (profiles !== undefined && profiles.length > 0) {
      const code = user.profile;
      onChangeProfileHandler("profile", code);


    }
  }, [profiles]);

  useEffect(() => {
    if (user && user.id !== undefined && user.id > 0) {
      if (selectedCountry === null) {
        onChangeCountriesHandler("countryid", user.country);
      }
      if (selectedOrganization === null) {
        onChangeOrganizationsHandler("organizationid", user.organization);
      }
      if (selectedCharge === null) {
        onChangeChargesHandler("chargeid", user.charge);
      }
      if (selectedDepartment === null) {
        onChangeDepartmentsHandler("departmentid", user.department);
      }
      if (selectedDocumenttype === null) {
        onChangeDocumenttypesHandler("documenttypeid", user.documentType);
      }
      if (selectedProfile === null) {
        onChangeProfileHandler("profile", user.profile);
      }
      if (selectedPassword === null) {
        setSelectedPassword(user.password);
      }
    }
  }, [user]);

  useEffect(() => {
    if (countries !== undefined && countries.length > 0) {
      const ct = countries.filter((ct) => ct.code === "DO")[0];
      setSelectedCountry({
        id: ct.id,
        code: ct.code,
        name: ct.name,
      });
    }
  }, [countries]);

  useEffect(() => {
    if (documenttypes !== undefined && documenttypes.length > 0) {
      const dt = documenttypes.filter((dt) => dt.code === "IDC")[0];

      setSelectedDocumenttype({
        id: dt.id,
        code: dt.code,
        name: dt.name,
      });
    }
  }, [documenttypes]);

  useEffect(() => {
    if (countries !== undefined && countries.length > 0) {
      const ct = countries.filter((ct) => ct.code === "DO")[0];
      setSelectedCountry({
        id: ct.id,
        code: ct.code,
        name: ct.name,
      });
    }
  }, [countries]);

  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      user.id > 0 &&
      restartPage
    ) {
      dispatch(userActions.restartState());
      window.location.href = `/external-signs/${user.id}/request/files`;
    }
  }, [user.id, dispatch, navigate, notification]);

  const onChangeHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
  };

  const onChangeCountriesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedCountry({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };

  const onChangeOrganizationsHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedOrganization({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };

  const selectedOrganizationTemplate = (option, props) => {
    if (
      selectedOrganization &&
      selectedOrganization.id !== undefined &&
      selectedOrganization.id > 0
    ) {
      return <div>{selectedOrganization.name}</div>;
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeProfileHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }

    setSelectedProfile(value);
  };

  const selectedProfileTemplate = (option, props) => {
    if (selectedProfile && selectedProfile.code !== undefined) {
      return (
        <>
          <div>{selectedProfile.name}</div>
        </>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeChargesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedCharge({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };

  const selectedDepartmentTemplate = (option, props) => {
    if (
      selectedDepartment &&
      selectedDepartment.id !== undefined &&
      selectedDepartment.id > 0
    ) {
      return <div>{selectedDepartment.name}</div>;
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeDepartmentsHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedDepartment({
      id: value.id,
      name: value.name,
    });
  };

  const selectedChargeTemplate = (option, props) => {
    if (
      selectedCharge &&
      selectedCharge.id !== undefined &&
      selectedCharge.id > 0
    ) {
      return <div>{selectedCharge.name}</div>;
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeDocumenttypesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(userActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(userActions.setFieldValid({ id, value: false }));
    }
    setSelectedDocumenttype({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (user.name === "") {
      dispatch(userActions.setFieldValid({ id: "name", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else {
      const newUser = {
        ...user,
        documenttypeId: selectedDocumenttype.id,
        countryId: selectedCountry.id,
        chargeId: selectedCharge.id,
        departmentId: selectedDepartment.id,
        organizationId: selectedOrganization.id,
        password: selectedPassword,
        isIntern: false,
      };

      dispatch(UpdateUser(newUser, userInfo.Email));
      restartPage = true;
    }
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };

  return (
    <>
      <Card
        style={{
          backgroundColor: "#F9FAFB",
          marginBottom: "0",
          boxShadow: "none",
          height: "auto",
          width: "100%",
          padding: "2rem",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="grid">
            {/* Primera fila - Nombre y Primer apellido */}
            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="name"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Nombre:
                </label>
                <InputText
                  id="name"
                  value={user.name}
                  onChange={(e) => onChangeHandler("name", e.target.value)}
                  placeholder=""
                  style={{ width: "100%" }}
                />
                <div>{getFormErrorMessage("name")}</div>
              </div>
            </div>

            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="surname1"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Primer apellido:
                </label>
                <InputText
                  id="surname1"
                  value={user.surname1}
                  onChange={(e) => onChangeHandler("surname1", e.target.value)}
                  placeholder=""
                  style={{ width: "100%" }}
                />
                <div>{getFormErrorMessage("surname1")}</div>
              </div>
            </div>

            {/* Segunda fila - Segundo apellido y País */}
            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="surname2"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Segundo Apellido:
                </label>
                <InputText
                  id="surname2"
                  value={user.surname2}
                  onChange={(e) => onChangeHandler("surname2", e.target.value)}
                  placeholder=""
                  style={{ width: "100%" }}
                />
                <div>{getFormErrorMessage("surname2")}</div>
              </div>
            </div>

            <div className="col-12 lg:col-6">
              <div className="field" style={{ marginBottom: "2.5%" }}>
                <label
                  htmlFor="countryid"
                  style={{
                    fontSize: "large",
                    color: "",
                    display: "block",
                    marginBottom: "0.5rem",
                  }}
                >
                  País:
                </label>
                {selectedCountry !== null && selectedCountry !== undefined ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      alt={selectedCountry.name}
                      src={`https://flagcdn.com/48x36/${selectedCountry.code.toLowerCase()}.png`}
                      style={{
                        width: "18px",
                        marginRight: "0.5rem",
                      }}
                    />
                    <span style={{ color: "#142f47", fontSize: "large" }}>
                      {selectedCountry.name}
                    </span>
                  </div>
                ) : (
                  <i
                    className="pi pi-spin pi-spinner"
                    style={{ fontSize: "1rem" }}
                  ></i>
                )}
              </div>
            </div>

            {/* Tercera fila - Organización y Departamento */}
            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="organizationid"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Organización:
                </label>
                <Dropdown
                  value={selectedOrganization}
                  onChange={(e) => {
                    onChangeOrganizationsHandler("organizationid", e.value);
                  }}
                  options={organizations}
                  optionLabel="name"
                  placeholder="Seleccionar organizacion"
                  valueTemplate={selectedOrganizationTemplate}
                  filter
                  style={{
                    width: "100%",
                    height: "50%",
                  }}
                />
                <div>{getFormErrorMessage("organizationid")}</div>
              </div>
            </div>

            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="departmentid"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Departamento:
                </label>
                <Dropdown
                  value={selectedDepartment}
                  onChange={(e) => {
                    onChangeDepartmentsHandler("departmentid", e.value);
                  }}
                  options={departments}
                  optionLabel="name"
                  placeholder="Seleccionar departamento"
                  valueTemplate={selectedDepartmentTemplate}
                  filter
                  style={{
                    width: "100%",
                    height: "50%",
                  }}
                />
                <div>{getFormErrorMessage("departmentid")}</div>
              </div>
            </div>

            {/* Cuarta fila - Cargo y Email */}
            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="charge"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Cargo:
                </label>
                <Dropdown
                  value={selectedCharge}
                  onChange={(e) => {
                    onChangeChargesHandler("chargeid", e.value);
                  }}
                  options={charges}
                  placeholder="Seleccionar cargo"
                  valueTemplate={selectedChargeTemplate}
                  optionLabel="name"
                  style={{
                    width: "100%",
                    height: "50%",
                  }}
                />
                <div>{getFormErrorMessage("organizationid")}</div>
              </div>
            </div>

            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="email"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Email:
                </label>
                <InputText
                  id="email"
                  value={user.email}
                  onChange={(e) => onChangeHandler("email", e.target.value)}
                  placeholder=""
                  style={{ width: "100%" }}
                />
                <div>{getFormErrorMessage("email")}</div>
              </div>
            </div>

            {/* Quinta fila - Perfil y Tipo de Documento */}
            <div className="col-12 lg:col-6">
              <div className="field" style={{ marginBottom: "2.5%" }}>
                <label
                  htmlFor="profile"
                  style={{
                    fontSize: "large",
                    color: "",
                    display: "block",
                    marginBottom: "0.5rem",
                  }}
                >
                  Perfil:
                </label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      fontSize: "large",
                      fontWeight: "bold",
                    }}
                  >
                    {profiles.find(profile => profile.code === selectedProfile)?.name}
                  </div>

                  {selectedProfile !== null &&
                    selectedProfile !== undefined &&
                    selectedProfile.name !== undefined && (
                      <>
                        <Button
                          type="button"
                          icon="pi pi-info-circle"
                          rounded
                          text
                          aria-label="Filter"
                          style={{ marginLeft: "1rem" }}
                          onClick={(e) => op.current.toggle(e)}
                        />

                        <OverlayPanel align ref={op}>
                          {selectedProfile !== undefined &&
                            selectedProfile.name !== undefined &&
                            selectedProfile.name === "Representante" && (
                              <span>
                                El representante es la persona que genera la
                                solicitud
                              </span>
                            )}
                          {selectedProfile !== undefined &&
                            selectedProfile.name !== undefined &&
                            selectedProfile.name === "Perteneciente" && (
                              <span>
                                El perteneciente es la persona para la cual se
                                genera la solicitud
                              </span>
                            )}
                        </OverlayPanel>
                      </>
                    )}
                </div>
              </div>
            </div>

            <div className="col-12 lg:col-6">
              <div className="field" style={{ marginBottom: "2.5%" }}>
                <label
                  htmlFor="documenttypeid"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Tipo de Documento:{" "}
                </label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {selectedDocumenttype !== null &&
                    selectedDocumenttype !== undefined ? (
                    <span
                      style={{
                        color: "#142f47",
                        fontWeight: "600",
                        fontSize: "large",
                      }}
                    >
                      {selectedDocumenttype.name}
                    </span>
                  ) : (
                    <i
                      className="pi pi-spin pi-spinner"
                      style={{ fontSize: "1rem" }}
                    ></i>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="identification"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Identificacion:
                </label>
                <InputMask
                  id="identification"
                  value={user.identification}
                  onChange={(e) =>
                    onChangeHandler("identification", e.target.value)
                  }
                  mask="999-9999999-9"
                  placeholder="999-9999999-9"
                  style={{ width:  "100%" }}
                />
                <div>{getFormErrorMessage("identification")}</div>
              </div>
            </div>

            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="cellPhone"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Teléfono:
                </label>
                <InputText
                  id="cellPhone"
                  value={user.cellPhone}
                  onChange={(e) => onChangeHandler("cellPhone", e.target.value)}
                  placeholder=""
                  style={{ width: "100%" }}
                />
                <div>{getFormErrorMessage("cellPhone")}</div>
              </div>
            </div>

            {/* Séptima fila - Ciudad y Dirección */}
            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="city"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Ciudad:
                </label>
                <InputText
                  id="city"
                  value={user.city}
                  onChange={(e) => onChangeHandler("city", e.target.value)}
                  placeholder=""
                  style={{ width: "100%" }}
                />
                <div>{getFormErrorMessage("city")}</div>
              </div>
            </div>

            <div className="col-12 lg:col-6">
              <div className="field">
                <label
                  htmlFor="address"
                  style={{ fontSize: "large", color: "", display: "block", marginBottom: "0.5rem" }}
                >
                  Dirección:
                </label>
                <InputText
                  id="address"
                  value={user.address}
                  onChange={(e) => onChangeHandler("address", e.target.value)}
                  placeholder=""
                  style={{ width: "100%" }}
                />
                <div>{getFormErrorMessage("address")}</div>
              </div>
            </div>

            {/* Botones */}
            <div className="col-12">
              <div className="field" style={{ display: "flex", gap: "1rem", flexWrap: "wrap", marginTop: "1rem" }}>
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff" }}
                  label="Regresar"
                  icon="pi pi-arrow-left"
                  className="p-button-danger"
                  onClick={() => {
                    navigate("/external-signs/users");
                  }}
                />
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff" }}
                  label="Guardar"
                  className="p-button-success"
                  icon={
                    notification && notification.status === "pending"
                      ? "pi pi-spin pi-spinner"
                      : "pi pi-save"
                  }
                  disabled={notification && notification.status === "pending"}
                />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </>
  );
};
export default ExternalSignForm;
